import FigmaRequestor from './FigmaRequestor'
import {uint8ArrayToBase64} from 'utils'
import selector, {identitySelector} from 'utils/selector'

export default class FigmaService {
  private requestor = new FigmaRequestor()

  public exportCurrentFrame = async () => {
    const result = await this.requestor.exec('exportCurrentFrame')
    return uint8ArrayToBase64(result)
  }
}

export const figmaServiceSelector = selector(identitySelector<string>(), () => new FigmaService())
